<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  /* height: 120px; */
  border-radius: 10px;

}
.card-flex{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.order-flex{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.card-flex-price{
    display: flex;
    align-items: center;
}
.card-flex-count{
    display: flex;
    align-items: center;
    justify-content: right;
}
.new-card{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    border-radius: 10px;
    margin: 5px;
    padding: 20px 5px;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.new-card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.d-none-width {
    width: 250px; 
    max-width: 250px; 
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.d-none-price {
    width: 200px;
}
.p-relative{
    position: relative;
}
.add-cart-button{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    background-color: #0057AD;
    border-radius: 50%;
}
.deliver{
    border:solid 1px #e3e3e3;
    border-radius:10px;
    display: flex;
    padding: 20px;
    align-items: center;
    margin: 10px 4px 10px 4px;
}
@media only screen and (max-width: 600px) {
    .card-phone {
        width: 89%;
    }
  .d-none-width {
    width: auto;
    max-width: 100%;
  }
  .d-none-link {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .d-none-price {
      width: auto;
  }
  .mobile-product {
      padding: 20px;
  }
  .order-none{
    display: none;
  }
}
</style>
<template>
    <div>
        <main id="content" role="main" class="cart-page" v-loading.fullscreen.lock="fullscreenLoading">
            <div class="container">
                <div class="row my-8">
                    <div class="col-2 col-md-3"></div>
                    <div class="col-8 col-md-6">
                        <div class="order-progress"> 
                            <div>
                                <div class="order-progress-first-circe order-progress-active"> 
                                    <img v-if="step==0" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div >Сагслах</div>
                                </div> 
                                <div class="order-progress-middle-line " :class="{'order-progress-active':step>=1}"></div> 
                                <div class="order-progress-second-circle " :class="{'order-progress-active':step>=1}">
                                    <img v-if="step==1" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div >Хаягын мэдээлэл оруулах</div>
                                </div>
                            </div>
                            <div >
                                <div class="order-progress-middle-line" :class="{'order-progress-active':step>=2}"></div> 
                                <div class="order-progress-third-circle" :class="{'order-progress-active':step>=2}">
                                    <img v-if="step==2" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div>Төлбөр төлөх</div>
                                </div>
                            </div>
                            </div>
                    </div>
                    <div class="col-2  col-md-3"></div>
                </div>
                <span style="float: right;margin-right: 20px;font-size: 16px;">Миний бонус <i class="fas fa-gift" style="font-size: 14px;margin:0 2px 0px 10px;"></i>{{checkBonus()}}</span>
                <div style="clear: both;"></div>
            </div>
            <div class="container">
                    <ul class="nav nav-classic-cart" id="pills-tab" role="tablist">
                         <li >
                                <a class="nav-link active" id="cart"  ref="cart" @click="changeActivity('cart')">
                                        <div class="d-md-flex ">
                                             Миний сагс
                                        </div>
                                </a>
                         </li>
                         <li >
                                 <a class="nav-link" id="saved" ref="saved" @click="changeActivity('saved')">
                                         <div class="d-md-flex">
                                                 Хадгалсан
                                         </div>
                                 </a>
                         </li>
                         <li >
                                 <a class="nav-link"  id="orders"   ref="orders" @click="changeActivity('orders')">
                                         <div class="d-md-flex ">
                                                 Миний захиалгууд
                                         </div>
                                 </a>
                         </li>
                    </ul>
                    <div class="tab-content" id="pills-tabContent">
                           <div class="tab-pane fade pt-2 show active " id="cart1" ref="cart1">
                                 <div class="row" v-if="cart.product.length > 0">
                                       <div class="mb-2 cart-table col-md-8" style="overflow: auto;">
                                            <form class="mb-4" action="javascript:;">
                                                 <div class="row new-card" v-for="(item, index) in cart.product" :key="index"> 
                                                         <div class="col-12 col-md-4">
                                                                <div class="card-flex check" style="align-items: center;"><input type="checkbox" v-model="item.checked" class="mr-2 ml-2" @change="changeChecked"><img class="img-fluid max-width-100 p-1 " :src="$appUrl+'/images/products/'+item.id+'.jpg'" alt="Image Description"></div>
                                                          </div>
                                                         <div class="col-12 col-md-4 card-flex-price pl-4">
                                                                <div> 
                                                                      <div>
                                                                            <span style="background-color: #c90201;font-size: 10px;color:azure;padding:3px 5px; margin: 0 2px 0 0; display: inline-block;" v-if="item.New_lower_price==1"><b>Хямдарсан</b></span>
                                                                            <span style="background-color: #dc0951;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0; display: inline-block;" v-if="item.Top_seller==1"><b>Эрэлттэй</b></span>
                                                                            <span style="background-color: #cc4f06;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.New==1"><b>ШИНЭ</b></span>
                                                                            <span style="background-color: #027bc4;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.IKEA_family_price==1"><b>IKEA family price</b></span>
                                                                            <span style="background-color:#fbda11;font-size: 10px;color:black;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.Last_chance==1"><b>Last chance</b></span>
                                                                       </div>
                                                                       <div class="text-gray-90 d-none-link"><span>{{item.name}}<br></span><strong>{{item.model}}</strong> #{{item.color_name}}</div>
                                                                       <div class="flex-center-between mb-1">
                                                                            <div v-if="item.regular_price >item.price" class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                                                                 <ins v-if="item.IKEA_family_price>0" class="font-size-20 ikea-family-price text-decoration-none mr-2">₮{{Number(item.price).toLocaleString()}}</ins>
                                                                                 <ins v-else class="font-size-20 text-red text-decoration-none mr-2">₮{{Number(item.price).toLocaleString()}}</ins>
                                                                                 <del class="font-size-12 tex-gray-6 position-absolute bottom-100" style="top: -9px;">₮{{Number(item.regular_price).toLocaleString()}}</del>
                                                                                 <span class="font-size-14" style="color: #80a1ed;" v-if="item.show_product==0">{{item.show_product==0 ? "Үлдэгдэлгүй" : item.show_product=="stock" ? "Бэлэн" :""}}</span>
                                                                                 <span class="font-size-14" style="color: #027bc4;" v-if="item.show_product=='stock'">{{item.show_product==0 ? "Үлдэгдэлгүй" : item.show_product=="stock" ? "Бэлэн" :""}}</span>
                                                                            </div>
                                                                            <div v-else class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                                                                 <ins class="font-size-20 text-decoration-none mr-2"><span><ins class="font-size-12 text-decoration-none tex-gray-6 bottom-100" style="vertical-align: middle;"><i class="fas fa-gift"></i> ₮{{Number(item.price / 100 * item.bonus_percent).toLocaleString()}} </ins></span> ₮{{Number(item.price).toLocaleString()}}</ins>
                                                                                 <span class="font-size-14" style="color:#80a1ed;" v-if="item.show_product==0">{{item.show_product==0 ? "Үлдэгдэлгүй" : item.show_product=="stock" ? "Бэлэн" : ""}}</span>
                                                                                 <span class="font-size-14" style="color:#027bc4;" v-if="item.show_product=='stock'">{{item.show_product==0 ? "Үлдэгдэлгүй" : item.show_product=="stock" ? "Бэлэн" : ""}}</span>
                                                                            </div>
                                                                        </div>
                                                                </div>
                                                         </div>
                                                          <div class="col-12 col-md-4 card-flex-count">
                                                                  <div > 
                                                                        <div class="mb-2 px-2" style="position: relative;"> 
                                                                              <a href="javascript:;" @click="addFav(item.id)" class="text-gray-8 font-size-13 ml-4 mr-3" ><i class="ec ec-favorites font-size-20"></i></a>
                                                                              <a href="javascript:;" @click="removeCart(item.id)" class="text-gray-8" style="position: absolute;top:1px"><i class="far fa-trash-alt font-size-18"></i></a>
                                                                        </div>
                                                                        <div class="input-number"> 
                                                                              <button class="counts" @click="item.qty>1 ? item.qty-- : null,changeQty(item.code)">-</button>
                                                                              <input type="number" v-model="item.qty" :min="1" :max="calcMaxQty(item.code)" class="product-count">
                                                                              <button class="counts" @click="item.qty++,changeQty(item.code)">+</button>
                                                                        </div>
                                                                    </div>
                                                         </div>
                                                   </div>
                                             </form>
                                      </div>
                                      <div class="mb-8 cart-total col-md-4 col-sm-4" align="center">
                                       <div class="row card p-5 mb-3">
                                          <div class="border-bottom border-color-1 mb-3 " align="right">
                                              <h3 class="d-inline-block mb-0 pb-2 font-size-22">Бүтээгдэхүүн</h3>
                                          </div>
                                          <table class="table mb-3 mb-md-0">
                                               <tbody>
                                                     <tr v-for="(item,index) in filteredProducts" :key="index" class="cart-subtotal">
                                                           <th >{{item.name}}</th>
                                                          <td  data-title="Subtotal"><span class="amount">{{item.qty}} X ₮{{Number(item.price).toLocaleString()}}</span></td>
                                                    </tr>
                                              </tbody>
                                          </table>
                                     </div>
                                     <div class="row card p-5">
                                         <div class="col-md-12">
                                             <div class="border-bottom border-color-1 mb-3" align="right">
                                                 <h4 class="d-inline-block  mb-0 pb-2 font-size-22">Захиалгын мэдээлэл</h4>
                                             </div>
                                             <table class="table mb-3 mb-md-0">
                                                 <tbody>
                                                       <tr class="cart-subtotal">
                                                             <th>Үнэ</th>
                                                             <td data-title="Subtotal"><span class="amount">₮{{Number(cart.subtotal).toLocaleString()}}</span></td>
                                                       </tr>
                                                       <tr class="cart-subtotal">
                                                             <th>Нэмэгдэх бонус</th>
                                                             <td data-title="Subtotal"><span class="amount">₮{{Number(parseInt(cart.bonus)).toLocaleString()}}</span></td>
                                                        </tr>
                                                </tbody>
                                            </table>
                                             <div style="border: solid 1px;"></div>
                                             <div style="display: flex;justify-content: space-between;align-items: center ;padding:0 12px;margin-top: 10px;"> 
                                                   <b class="total-amount">Нийт дүн</b>
                                                   <span class="price font-size-18 font-weight-bold">{{Number(parseInt(cart.subtotal - cart.sale)).toLocaleString()}}</span>
                                             </div>
                                        </div>
                                  </div>
                                  <div class="row pl-1 pr-1">
                                  <div class="col-md-12" align="center">
                                          <button type="button" @click="Shpping" class="btn btn-primary-dark-w mt-5" style="width: 100%; border-radius: 12px;">Хаяг баталгаажуулах</button>
                                  </div>
                            </div>
                                      </div>
                                 </div>
                           </div>
                           <div class="tab-pane fade pt-2 show" id="saved1" ref="saved1">
                                 <div class="row" v-if="favourites.favourite.length > 0">
                                       <div class="mb-2 cart-table col-md-8" style="overflow: auto;">
                                            <form class="mb-4" action="javascript:;">
                                                <div class="row"> 
                                               <div class="col-12">
                                                  <div class="deliver" style="background-color: #fad419;"> 
                                                        <i class="ec ec-favorites font-size-24" style="width: 40px;height:100%; margin:0 10px;"></i>
                                                    <span>Таны зүрх дарж хадгалсан бараа хямдарсан тохиолдолд бид танд цаг алдалгүй мэдэгдэх болно.</span>
                                                  </div>
                                                 </div>
                                               </div>
                                                 <div class="row new-card" v-for="(item, index) in favourites.favourite" :key="index"> 
                                                         <div class="col-12 col-md-3">
                                                                <div class="card-flex check" style="align-items: center;"><i class="ec ec-favorites font-size-24"></i><img class="img-fluid max-width-100 p-1 " :src="item.image" alt="Image Description"></div>
                                                          </div>
                                                         <div class="col-12 col-md-3 card-flex-price pl-4">
                                                                <div> 
                                                                       <div class="text-gray-90 d-none-link"><span>{{item.name}}<br></span><strong>{{item.code}}</strong> #{{item.color_name}}</div>
                                                                </div>
                                                         </div>
                                                          <div class="col-12 col-md-6 card-flex-price">
                                                                <del class="col-4 font-size-20" style="margin-top: -4px" v-if="item.Regular_price_tug!=item.price_tug">₮{{Number(item.Regular_price_tug).toLocaleString()}}</del>
                                                                <span class="col-4 font-size-20" style="margin-top: -4px" v-else>₮{{Number(item.price_tug).toLocaleString()}}</span>
                                                                <div class="col-4">
                                                                   <span style="background-color: #c90201;font-size: 10px;color:azure;padding:3px 5px; margin: 0 2px 0 0; display: inline-block;" v-if="item.New_lower_price==1"><b>Хямдарсан</b></span>
                                                                   <span style="background-color: #dc0951;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0; display: inline-block;" v-if="item.Top_seller==1"><b>Эрэлттэй</b></span>
                                                                   <span style="background-color: #cc4f06;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.New==1"><b>ШИНЭ</b></span>
                                                                   <span style="background-color: #027bc4;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.IKEA_family_price==1"><b>IKEA family price</b></span>
                                                                   <span style="background-color:#fbda11;font-size: 10px;color:black;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.Last_chance==1"><b>Last chance</b></span>
                                                                   <div class="flex-center-between mb-1">
                                                                            <div v-if="item.special_price > 0" class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                                                                 <ins v-if="item.IKEA_family_price>0" class="font-size-20 ikea-family-price text-decoration-none mr-2">₮{{Number(item.price_tug).toLocaleString()}}</ins>
                                                                                 <ins v-else class="font-size-20 text-red text-decoration-none mr-2">₮{{Number(item.price_tug).toLocaleString()}}</ins>
                                                                            </div>
                                                                            <div v-else-if="item.sale > 0" class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                                                                 <ins v-if="item.IKEA_family_price>0" class="font-size-20 ikea-family-price text-decoration-none mr-2">₮{{Number(item.price_tug).toLocaleString()}}</ins>
                                                                                 <ins v-else class="font-size-20 text-red text-decoration-none mr-2">₮{{Number(item.price_tug).toLocaleString()}}</ins>
                                                                            </div>
                                                                            <div v-else class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                                                                 <ins class="font-size-20 text-decoration-none mr-2"><span>
                                                                                </span> ₮{{Number(item.price_tug).toLocaleString()}}</ins>
                                                                            </div>
                                                                        </div>
                                                                </div>
                                                                <div class="col-4 card-flex-price"> 
                                                                    <a href="javascript:;" @click="removeFavourite(item.code)" class="text-gray-8 mr-2 ml-4" ><i class="far fa-trash-alt font-size-16"></i></a>
                                                                    <a href="javascript:;" @click="addcart(item)" class="add-cart-button"><i class="ec ec-add-to-cart font-size-12" style="color: #ebebeb"></i></a>
                                                                </div>
                                                         </div>
                                                   </div>
                                             </form>
                                      </div>
                                      <div class="mb-8 cart-total col-md-4 col-sm-4" align="center">
                                       <div class="row card p-5 mb-3">
                                          <div class="border-bottom border-color-1 mb-3 " align="right">
                                              <h3 class="d-inline-block mb-0 pb-2 font-size-22">Бүтээгдэхүүн</h3>
                                          </div>
                                          <table class="table mb-3 mb-md-0">
                                               <tbody>
                                                     <tr v-for="(item,index) in filteredProducts" :key="index" class="cart-subtotal">
                                                           <th >{{item.name}}</th>
                                                          <td  data-title="Subtotal"><span class="amount">{{item.qty}} X ₮{{Number(item.price).toLocaleString()}}</span></td>
                                                    </tr>
                                              </tbody>
                                          </table>
                                     </div>
                                     <div class="row card p-5">
                                         <div class="col-md-12">
                                             <div class="border-bottom border-color-1 mb-3" align="right">
                                                 <h4 class="d-inline-block  mb-0 pb-2 font-size-22">Захиалгын мэдээлэл</h4>
                                             </div>
                                             <table class="table mb-3 mb-md-0">
                                                 <tbody>
                                                       <tr class="cart-subtotal">
                                                             <th>Үнэ</th>
                                                             <td data-title="Subtotal"><span class="amount">₮{{Number(cart.subtotal).toLocaleString()}}</span></td>
                                                       </tr>
                                                       <tr class="cart-subtotal">
                                                             <th>Нэмэгдэх бонус</th>
                                                             <td data-title="Subtotal"><span class="amount">₮{{Number(parseInt(cart.bonus)).toLocaleString()}}</span></td>
                                                        </tr>
                                                </tbody>
                                            </table>
                                             <div style="border: solid 1px;"></div>
                                             <div style="display: flex;justify-content: space-between;align-items: center ;padding:0 12px;margin-top: 10px;"> 
                                                   <b class="total-amount">Нийт дүн</b>
                                                   <span class="price font-size-18 font-weight-bold">{{Number(parseInt(cart.subtotal - cart.sale)).toLocaleString()}}</span>
                                             </div>
                                        </div>
                                  </div>
                                  <div class="row pl-1 pr-1">
                                  <div class="col-md-12" align="center">
                                          <button type="button" @click="Shpping" class="btn btn-primary-dark-w mt-5" style="width: 100%; border-radius: 12px;">Хаяг баталгаажуулах</button>
                                  </div>
                            </div>
                                      </div>
                                 </div>
                           </div>
                           <div class="tab-pane fade pt-2 show" id="orders1"  ref="orders1">
                                 <div class="row"> 
                                        <div class="mb-2 cart-table col-md-8" style="overflow: auto;"> 
                                            <div class="new-card" >
                                                <table style="width: 100%;vertical-align: top;"> 
                                                    <tr v-for="(item,i) in orders.order" :key="i">
                                                            <td style="padding-left: 20px;"> 
                                                                <router-link :to="'/show-order/'+item.ordernumber"> <span style="color:black">#{{item.ordernumber}} </span></router-link>         
                                                            </td>
                                                            <td class="order-none"> 
                                                                <router-link :to="'/show-order/'+item.ordernumber"> <span style="color:black">{{String(item.created_at).split("T")[0]}} </span></router-link>                                                                
                                                            </td>
                                                            <td  class="order-none"> 
                                                                <router-link :to="'/show-order/'+item.ordernumber"> <span style="color:black">₮{{Number(item.total_amount+item.lend_fee).toLocaleString()}}</span></router-link>                                     
                                                            </td>
                                                            <td style="max-width: 150px;">
                                                                <router-link :to="'/show-order/'+item.ordernumber">
                                                                    <span v-if="item.status=='pending'" class="ikea-family-price">Хүлээгдэж байгаа</span>
                                                                    <span v-if="item.status=='paid' && item.residual==0" class="text-green">Төлөгдсөн</span>
                                                                    <span v-if="item.status=='paid' && item.payment=='ZeeLAB' && item.residual>0" class="text-green">Төлбөр дутуу</span>
                                                                    <span v-if="item.status=='ordered'" class="text-black">Баталгаажсан</span>
                                                                    <span v-if="item.status=='loaded'" class="text-red">Бээжин дахь IKEA дэлгүүрээс ачигдсан</span>
                                                                    <span v-if="item.status=='came_in_ereen'" class="text-red">Эрээнд ирсэн</span>
                                                                    <span v-if="item.status=='came_in_ub'" class="text-success">Улаанбаатарт ирсэн ялгалт хийгдэж байна</span>
                                                                    <span v-if="item.status=='in_stock'" class="text-success">Хэрэглэгчийн хаяг болон түгээлтийн  байршилруу хүргэлт хийгдэж байна</span>
                                                                    <span v-if="item.status=='delivered'" class="text-cyan">Амжилттай гарт олгогдсон</span>
                                                                    <span v-if="item.status=='expired'" class="text-sale">Цуцлагдсан</span>
                                                                </router-link>
                                                                </td>
                                                    </tr>
                                                </table> 
                                                <!-- <div v-for="(item, index) in orders.order" :key="index" style="font-size: 12px;margin-top: 6px;cursor: pointer;"> 
                                                       <div class="card-flex">
                                                          <router-link :to="'/show-order/'+item.ordernumber"><span style="color: #0057AD;font-weight: 600;">#{{item.ordernumber}}</span> </router-link> 
                                                          <span class="order-none">{{String(item.created_at).split("T")[0]}}</span>
                                                         <span  class="order-none">{{Number(item.total_amount+item.lend_fee).toLocaleString()}}</span>
                                                         <span v-if="item.status=='pending'" class="ikea-family-price">Хүлээгдэж байгаа</span>
                                                         <span v-if="item.status=='paid'" class="ikea-family-price">Төлөгдсөн</span>
                                                         <span v-if="item.status=='expired'" class="ikea-family-price">Цуцлагдсан</span>
                                                         <span v-if="item.status=='delivered'" class="ikea-family-price">Хүргэгдсэн</span>
                                                         <a href="javascript:;" @click="removeCart(item.id)" class="text-gray-8" ><i class="far fa-trash-alt font-size-12"></i></a>
                                                       </div>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="mb-8 cart-total col-md-4 col-sm-4" align="center">
                                       <div class="row card p-5 mb-3">
                                          <div class="border-bottom border-color-1 mb-3 " align="right">
                                              <h3 class="d-inline-block mb-0 pb-2 font-size-22">Бүтээгдэхүүн</h3>
                                          </div>
                                          <table class="table mb-3 mb-md-0">
                                               <tbody>
                                                     <tr v-for="(item,index) in filteredProducts" :key="index" class="cart-subtotal">
                                                           <th >{{item.name}}</th>
                                                          <td  data-title="Subtotal"><span class="amount">{{item.qty}} X ₮{{Number(item.price).toLocaleString()}}</span></td>
                                                    </tr>
                                              </tbody>
                                          </table>
                                     </div>
                                     <div class="row card p-5">
                                         <div class="col-md-12">
                                             <div class="border-bottom border-color-1 mb-3" align="right">
                                                 <h4 class="d-inline-block  mb-0 pb-2 font-size-22">Захиалгын мэдээлэл</h4>
                                             </div>
                                             <table class="table mb-3 mb-md-0">
                                                 <tbody>
                                                       <tr class="cart-subtotal">
                                                             <th>Үнэ</th>
                                                             <td data-title="Subtotal"><span class="amount">₮{{Number(cart.subtotal).toLocaleString()}}</span></td>
                                                       </tr>
                                                       <tr class="cart-subtotal">
                                                             <th>Нэмэгдэх бонус</th>
                                                             <td data-title="Subtotal"><span class="amount">₮{{Number(parseInt(cart.bonus)).toLocaleString()}}</span></td>
                                                        </tr>
                                                </tbody>
                                            </table>
                                             <div style="border: solid 1px;"></div>
                                             <div style="display: flex;justify-content: space-between;align-items: center ;padding:0 12px;margin-top: 10px;"> 
                                                   <b class="total-amount">Нийт дүн</b>
                                                   <span class="price font-size-18 font-weight-bold">{{Number(parseInt(cart.subtotal - cart.sale)).toLocaleString()}}</span>
                                             </div>
                                        </div>
                                  </div>
                                  <div class="row pl-1 pr-1">
                                  <div class="col-md-12" align="center">
                                          <button type="button" @click="Shpping" class="btn btn-primary-dark-w mt-5" style="width: 100%; border-radius: 12px;">Хаяг баталгаажуулах</button>
                                  </div>
                            </div>
                                      </div>
                                 </div>
                           </div>
                    </div>

                <!-- <div class="row" v-if="cart.product.length > 0">
                    <div class="mb-2 cart-table col-md-8" style="overflow: auto;">
                        <form class="mb-4" action="javascript:;">
                            <div class="row new-card" v-for="(item, index) in cart.product" :key="index"> 
                              <div class="col-12 col-md-4">
                                <div class="card-flex check" style="align-items: center;"><input type="checkbox" v-model="item.checked" class="mr-2 ml-2" @change="changeChecked"><img class="img-fluid max-width-100 p-1 " :src="item.image" alt="Image Description"></div>
                              </div>
                              <div class="col-12 col-md-4 card-flex-price pl-4">
                                <div> 
                                    <div>
                                  <span style="background-color: #c90201;font-size: 10px;color:azure;padding:3px 5px; margin: 0 2px 0 0; display: inline-block;" v-if="item.New_lower_price==1"><b>Хямдарсан</b></span>
                                  <span style="background-color: #dc0951;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0; display: inline-block;" v-if="item.Top_seller==1"><b>Эрэлттэй</b></span>
                                  <span style="background-color: #cc4f06;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.New==1"><b>ШИНЭ</b></span>
                                  <span style="background-color: #027bc4;font-size: 10px;color:azure;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.IKEA_family_price==1"><b>IKEA family price</b></span>
                                  <span style="background-color:#fbda11;font-size: 10px;color:black;padding:3px  5px;margin: 0 2px 0 0;display: inline-block;" v-if="item.Last_chance==1"><b>Last chance</b></span>
                               </div>
                               <div class="text-gray-90 d-none-link"><span>{{item.name}}<br></span><strong>{{item.model}}</strong> #{{item.color_name}}</div>
                               <div class="flex-center-between mb-1">
                                   <div v-if="item.special_price > 0" class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                         <ins v-if="item.IKEA_family_price>0" class="font-size-20 ikea-family-price text-decoration-none mr-2">₮{{Number(item.price).toLocaleString()}}</ins>
                                         <ins v-else class="font-size-20 text-red text-decoration-none mr-2">₮{{Number(item.price).toLocaleString()}}</ins>
                                         <del class="font-size-12 tex-gray-6 position-absolute bottom-100" style="top: -9px;">₮{{Number(item.regular_price).toLocaleString()}}</del>
                                    </div>
                                    <div v-else class="prodcut-price d-flex align-items-center flex-wrap position-relative">
                                         <ins class="font-size-20 text-decoration-none mr-2"><span><ins class="font-size-12 text-decoration-none tex-gray-6 bottom-100" style="vertical-align: middle;"><i class="fas fa-gift"></i> ₮{{Number(item.price / 100 * item.bonus_percent).toLocaleString()}} </ins></span> ₮{{Number(item.price).toLocaleString()}}</ins>
                                    </div>
                                </div>
                                </div>
                              </div>
                              <div class="col-12 col-md-4 card-flex-count">
                              <div > 
                                <div class="mb-2 px-2" style="position: relative;"> 
                                    <a href="javascript:;" @click="addFav(item.id)" class="text-gray-8 font-size-13 ml-4 mr-3" ><i class="ec ec-favorites font-size-20"></i></a>
                                    <a href="javascript:;" @click="removeCart(item.id)" class="text-gray-8" style="position: absolute;top:1px"><i class="far fa-trash-alt font-size-18"></i></a>
                                </div>
                                <div class="input-number"> 
                                    <button class="counts" @click="item.qty>1 ? item.qty-- : null,changeQty(item.id)">-</button>
                                    <input type="number" v-model="item.qty" :min="1" :max="calcMaxQty(item.id)" class="product-count">
                                    <button class="counts" @click="item.qty++,changeQty(item.id)">+</button>
                                </div>
                                  </div>
                              </div>
                            </div>
                        </form>
                    </div>
                    <div class="mb-8 cart-total col-md-4 col-sm-4" align="center">
                        <div class="row card p-5 mb-3">
                                <div class="border-bottom border-color-1 mb-3 " align="right">
                                    <h3 class="d-inline-block mb-0 pb-2 font-size-22">Бүтээгдэхүүн</h3>
                                </div>
                                <table class="table mb-3 mb-md-0">
                                    <tbody>
                                        <tr v-for="(item,index) in filteredProducts" :key="index" class="cart-subtotal">
                                            <th >{{item.name}}</th>
                                            <td  data-title="Subtotal"><span class="amount">{{item.qty}} X ₮{{Number(item.price).toLocaleString()}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        <div class="row card p-5">
                            <div class="col-md-12">
                                <div class="border-bottom border-color-1 mb-3" align="right">
                                    <h4 class="d-inline-block  mb-0 pb-2 font-size-22">Захиалгын мэдээлэл</h4>
                                </div>
                                <table class="table mb-3 mb-md-0">
                                    <tbody>
                                        <tr class="cart-subtotal">
                                            <th>Үнэ</th>
                                            <td data-title="Subtotal"><span class="amount">₮{{Number(cart.subtotal).toLocaleString()}}</span></td>
                                        </tr>
                                        <tr class="cart-subtotal">
                                            <th>Нэмэгдэх бонус</th>
                                            <td data-title="Subtotal"><span class="amount">₮{{Number(parseInt(cart.bonus)).toLocaleString()}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style="border: solid 1px;"></div>
                                <div style="display: flex;justify-content: space-between;align-items: center ;padding:0 12px;margin-top: 10px;"> 
                                   <b class="total-amount">Нийт дүн</b>
                                   <span class="price font-size-18 font-weight-bold">{{Number(parseInt(cart.subtotal - cart.sale)).toLocaleString()}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row pl-1 pr-1">
                            <div class="col-md-12" align="center">
                                <button type="button" @click="Shpping" class="btn btn-primary-dark-w mt-5" style="width: 100%; border-radius: 12px;">Хаяг баталгаажуулах</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="mb-4" style="text-align: center;">
                     <h5 class="ml-1"> Миний сагс</h5>
                   </div>
                    <div align="center">
                        <img src="@/assets/images/logo/cart.png" style="width: 25%; height: auto;" class="mb-2"><br>
                        <p style="font-size: 22px; font-weight: 700;" class="mb-1">{{valuetext}}</p>
                    </div>
                </div> -->
            </div>
        </main>
        <Brands />
    </div>
</template>
<script>
import Brands from "@/components/brands";
export default {
    components: {
        Brands
    },
    data() {
        return {
            valuetext: 'Түр хүлээнэ үү...',
            fullscreenLoading: false,
            step:0,
            cart: {
                product: [],
                real: [],
                subtotal: 0,
                sale: 0,
                bonus: 0,
            },
            orders:{
                order:[],
                noOrder:'Захиалга алга'
            },
            favourites:{
                favourite:[],
                noFavourite:'Хадгалсан бүтээгдэхүүн алга'
            }
        }
    },
    mounted() {
        let role = this.$route.query.role;
        this.changeActivity(`${role}`);
        this.$emit('getJquery');
        this.getProduct();
        this.getOrders();
    },
    beforeRouteLeave(to, from , next){
        const token = localStorage.getItem('token');
        if(token){
            const cart=JSON.parse(localStorage.getItem('cart'));
            if(cart && cart.length>0){
                let products=[];
                cart.forEach(el=>{
                    const { model, checked, qty } = el;
                    products.push({model,checked,qty});
                });
                var rts=this;
                rts.$axios({
                    method:'POST',
                    url:rts.$appUrl+'/api/user/update-cart',
                    headers:{
                        Authorization:`Bearer ${token}`
                    },
                    data:{
                        products
                    }
                }).then(data=>{
                     if(data.data.result=="success"){

                     }
                })
            }
        }
        next();
    },
    computed:{
        filteredProducts(){
            let products=[];
            if(this.cart.product.length>0){
                this.cart.product.forEach(el=>{
                    if(el.checked==true){
                        products.push(el);
                    }
                })
            }
            return products;
        }
    },
    methods: {
        changeActivity(value) {
            var tabs = ['cart', 'saved', 'orders'];
            tabs.forEach(element => {
                if(element == value) {
                    this.$refs[element].classList.add('active');
                    this.$refs[element+'1'].classList.add('active');
                } else {
                    this.$refs[element].classList.remove('active');
                    this.$refs[element+'1'].classList.remove('active');
                }
            });
        },
        addcart(item) {
            this.$emit('addCart', [1, item]);
            this.getProduct();
        },
        removeFavourite(id) {
            const token = localStorage.getItem('token');
            var rts = this;
            rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/product/remove-favourite',
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: {
                    id: id
                }
            }).then(data => {
                rts.favourites.favourite.forEach((el, index) => {
                    if(id == el.code) {
                        rts.favourites.favourite.splice(index,1);
                    }
                });
            });
        },
        checkBonus() {
            const user = JSON.parse(localStorage.getItem('user'));
            if(user) {
                return `${Number(user.bonus).toLocaleString()}`
            } else {
                return '';
            }
        },
        compRegForNOAT(){
            var noat=this.NOAT
            if(noat==true){
                window.document.getElementById('noatDet').classList.remove("notNone");
                window.document.getElementById('noatDet').classList.add("showNOAT");
            }else{
                window.document.getElementById('noatDet').classList.remove("showNOAT");
                window.document.getElementById('noatDet').classList.add("notNone");
            }
        },
        addFav(item) {
            this.$emit('addFavourite', item);
        },
        Shpping() {
            const token = localStorage.getItem('token');
            const cart = JSON.parse(localStorage.getItem('cart'));
            let ch=false;
            let not=false;
            if(cart!=null && cart.length>0){
                cart.forEach(el=>{
                    if(el.checked && el.show_product!=0){
                        ch=true;
                    }else if(el.checked && el.show_product==0){
                        not=true;
                    }
                })
            }
            if(!token) {
                this.$notify({
                    title: 'Амжилтгүй',
                    message: `Нэвтэрсэн байх шаардлагатай`,
                    type: 'error'
                });
                this.$router.push('/login');
            }else if(ch){
                if(not){
                    this.$notify({
                    title: 'Мэдэгдэл',
                    message: `Үлдэгдэлгүй бүтээгдэхүүн хасагдлаа`,
                    type: 'error'
                });
                this.$router.push('/shipping');
                }else{
                    this.$router.push('/shipping');
                }
            } else {
                this.$notify({
                    title: 'Амжилтгүй',
                    message: `Худалдан авах бүтээгдэхүүн үлдэгдэлтэй эсэхийг шалгана уу`,
                    type: 'error'
                });
            }
        },
        removeCart(id) {
            this.$emit('removeCart', id);
            this.cart.product.forEach((element, index) => {
                if(element.id == id) {
                    this.cart.product.splice(index, 1);
                }
            });
            this.calculate();
        },
        calculate() {
            var subtotal = 0; var sale = 0; var bonus = 0;
            this.cart.product.forEach(element => {
               if(element.checked){
                subtotal = subtotal + (element.price * element.qty);
                if(element.discount > 0) {
                    sale = sale + ((element.price- (element.price * ((100 - element.discount) / 100 ))) * element.qty);
                    bonus = bonus + (((element.price* ((100 - element.discount) / 100 )) * (element.bonus / 100)) * element.qty);
                } else {
                    bonus = bonus + ((element.price* (element.bonus / 100)) * element.qty);
                }
               }
            });
            this.cart.subtotal = subtotal;
            this.cart.bonus = bonus;
            this.cart.sale = sale;
        },
        changeQty(id) {
            localStorage.cart = JSON.stringify(this.cart.product);
            this.$emit('calcCart');
            this.calculate();
        },
        changeChecked(){;
            localStorage.cart = JSON.stringify(this.cart.product);
            this.calculate();
        },
        calcMaxQty(id) {
            var remain = 0;
            this.cart.product.forEach(element => {
                if(element.code == id) {
                    remain = element.remain;
                }
            });
            return remain;
        },
        getProduct() {
            var id = [];
            let cart =JSON.parse(localStorage.getItem('cart'));  
            let token=localStorage.getItem('token');    
            var rts = this;
                if(cart!=null){
                    cart.forEach(element => {
                    id.push(element.id);
                 });
                }else{
                    cart=[]
                }
                rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/product/cart-product',
                headers: {},
                data: {
                    products: id,
                    token
                }
            }).then(function(data) {
                rts.cart.real = data.data.product;
                data.data.product.forEach(element => {
                    cart.forEach(c => {
                        if(c.id == element.code) {
                            c.discount = element.discount;
                            c.bonus = element.bonus_percent;
                            c.Top_seller=element.Top_seller;
                            c.Last_chance=element.Last_chance;
                            c.New_lower_price=element.New_lower_price;
                            c.New=element.New;
                            c.IKEA_family_price=element.IKEA_family_price;
                            c.bonus_percent=element.bonus_percent;
                            c.regular_price=element.Regular_price_tug;
                            c.price=element.price_tug;
                            c.color_name=element.color_name;
                            c.sale=element.sale
                            c.chinaDeliver=element.china_deliver;
                            c.show_product=element.show_product;
                            if(c.checked===undefined){
                                c.checked=true;
                            }
                        }
                    });
                });
                if(data.data.cart && cart.length>0){
                    data.data.cart.forEach(e=>{
                        let index=cart.findIndex(el=>el.id===e.code);
                        if(index!==-1){
                            cart[index].discount = e.discount;
                            cart[index].bonus = e.bonus_percent;
                            cart[index].Top_seller=e.Top_seller;
                            cart[index].Last_chance=e.Last_chance;
                            cart[index].New_lower_price=e.New_lower_price;
                            cart[index].New=e.New;
                            cart[index].IKEA_family_price=e.IKEA_family_price;
                            cart[index].bonus_percent=e.bonus_percent;
                            cart[index].regular_price=e.Regular_price_tug;
                            cart[index].price=e.price_tug;
                            cart[index].color_name=e.color_name;
                            cart[index].sale=e.sale;
                            cart[index].name=e.name;
                            cart[index].qty=e.quantity;
                            cart[index].checked=e.checked;
                            cart[index].image=e.image;
                            cart[index].show_product=e.show_product;
                            cart[index].chinaDeliver=e.china_deliver;
                        }else{
                            let p={};
                            p.discount = e.discount;
                            p.bonus = e.bonus_percent;
                            p.Top_seller=e.Top_seller;
                            p.Last_chance=e.Last_chance;
                            p.New_lower_price=e.New_lower_price;
                            p.New=e.New;
                            p.IKEA_family_price=e.IKEA_family_price;
                            p.bonus_percent=e.bonus_percent;
                            p.regular_price=e.Regular_price_tug;
                            p.price=e.price_tug;
                            p.color_name=e.color_name;
                            p.sale=e.sale;
                            p.name=e.name;
                            p.qty=e.quantity;
                            p.checked=e.checked;
                            p.id=e.code;
                            p.model=e.code;
                            p.show_product=e.show_product;
                            p.chinaDeliver=e.china_deliver;
                            cart.push(p);
                        }
                    })
                }else if( data.data.cart && cart.length==0){
                           data.data.cart.forEach(e=>{
                            let p={};
                            p.discount = e.discount;
                            p.bonus = e.bonus_percent;
                            p.Top_seller=e.Top_seller;
                            p.Last_chance=e.Last_chance;
                            p.New_lower_price=e.New_lower_price;
                            p.New=e.New;
                            p.IKEA_family_price=e.IKEA_family_price;
                            p.bonus_percent=e.bonus_percent;
                            p.regular_price=e.Regular_price_tug;
                            p.price=e.price_tug;
                            p.color_name=e.color_name;
                            p.sale=e.sale;
                            p.name=e.name;
                            p.qty=e.quantity;
                            p.checked=e.checked
                            p.id=e.code;
                            p.image=e.image;
                            p.model=e.code;
                            p.show_product=e.show_product;
                            p.chinaDeliver=e.china_deliver;
                            cart.push(p);
                           })
                        }
                localStorage.cart = JSON.stringify(cart);
                rts.cart.product = cart;
                rts.calculate();
            }).catch(error => {
                console.log(error);
            })
        },
        getOrders(){
            const token = localStorage.getItem('token');
            var rts=this;
            if(token){
                  rts.$axios({
                    method:'GET',
                    url: rts.$appUrl + '/api/product/cart-orders',
                    headers: {
                       "Authorization": `Bearer ${token}`
                    }
                   }).then(data=>{
                    rts.orders.order=data.data.orders;
                    rts.favourites.favourite=data.data.fav;
                   })
            }
        }
    }
}
</script>